import axios from 'axios';
import { getToken, refreshToken, logout as keycloakLogout, isAuthenticated } from '@/services/keycloak';
import { auth } from '@/lib/firebase';

// Create axios instance
const api = axios.create({
  baseURL: (import.meta.env.VITE_API_URL || 'http://localhost:3013') + '/api',
});

// Add request interceptor to include bearer token
api.interceptors.request.use(
  async (config) => {
    const token = getToken();
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

// Add response interceptor to handle 401 errors
api.interceptors.response.use(
  (response) => response,
  async (error) => {
    const originalRequest = error.config;

    // If 401 error and we haven't retried yet
    if (error.response?.status === 401 && !originalRequest._retry) {
      originalRequest._retry = true;

      try {
        // Try to refresh the token
        const refreshed = await refreshToken();

        if (refreshed) {
          // Retry the original request with new token
          const token = getToken();
          if (token) {
            originalRequest.headers.Authorization = `Bearer ${token}`;
          }
          return api(originalRequest);
        } else {
          // Refresh failed, logout based on auth type
          if (isAuthenticated()) {
            keycloakLogout();
          } else {
            auth.signOut();
          }
          return Promise.reject(error);
        }
      } catch (refreshError) {
        // Refresh failed, logout based on auth type
        if (isAuthenticated()) {
          keycloakLogout();
        } else {
          auth.signOut();
        }
        return Promise.reject(refreshError);
      }
    }

    return Promise.reject(error);
  }
);

export default api;
